/* Kick Frame — stadiontribune als bovenrand van de footer: silhouet met gebogen dak,
   rijen publiek, twee lichtmasten met gouden gloed. Alleen SVG; de breedte van de tekening
   past zich aan het scherm aan, zodat niets uitgerekt wordt en de masten altijd in beeld staan. */
(function () {
  var footer = document.querySelector('.site-footer');
  if (!footer) return;
  var H = 120;

  var css = ''
    + '.kf-stand{display:block;width:100%;height:clamp(72px,9vw,120px);margin:0;background:transparent;pointer-events:none}'
    + '.kf-stand svg{display:block;width:100%;height:100%}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var wrap = document.createElement('div');
  wrap.className = 'kf-stand';
  wrap.setAttribute('aria-hidden', 'true');
  footer.parentNode.insertBefore(wrap, footer);

  // vaste "willekeur", zodat het publiek bij elke opbouw hetzelfde staat
  function rnd(n) { var x = Math.sin(n * 12.9898) * 43758.5453; return x - Math.floor(x); }

  function draw() {
    var h = wrap.getBoundingClientRect().height || H;
    var W = Math.max(480, Math.round(wrap.clientWidth * H / h));
    var bg = getComputedStyle(footer).backgroundColor || '#101d17';
    // kom-vorm zoals een tribune vanaf het veld gezien: hoog aan de zijkanten, lager in het midden
    function roof(x) { var u = 2 * x / W - 1; return 30 + 26 * (1 - u * u); }

    var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">'
      + '<defs><radialGradient id="kfStandGlow" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#ffe9b0" stop-opacity=".55"/>'
      + '<stop offset="1" stop-color="#ffe9b0" stop-opacity="0"/></radialGradient></defs>';

    // tribune: dak volgt een flauwe boog, daaronder alles in de footerkleur
    var line = 'M0 ' + roof(0).toFixed(1);
    for (var x = W / 24; x <= W + .1; x += W / 24) line += ' L' + x.toFixed(1) + ' ' + roof(x).toFixed(1);
    s += '<path d="' + line + ' L' + W + ' ' + H + ' L0 ' + H + ' Z" fill="' + bg + '"/>';
    // dakrand in goud
    s += '<path d="' + line + '" fill="none" stroke="#d6b25e" stroke-opacity=".45" stroke-width="1.2"/>';

    // rijen publiek: kleine hoofdjes, hier en daar een sjaal in goud of crème
    var n = 0;
    for (var row = 0; row < 5; row++) {
      var off = 16 + row * 11;
      for (var px = 8 + (row % 2) * 5; px < W - 6; px += 10) {
        n++;
        if (rnd(n) < .12) continue;   // lege stoel
        var y = roof(px) + off + (rnd(n + 7) - .5) * 2;
        if (y > H - 6) continue;
        var c = row % 2 ? '#22392d' : '#1e3529', o = 1;
        if (rnd(n + 3) < .06) { c = '#d6b25e'; o = .55; } else if (rnd(n + 5) < .05) { c = '#f4efe2'; o = .45; }
        s += '<circle cx="' + px + '" cy="' + y.toFixed(1) + '" r="3" fill="' + c + '" opacity="' + o + '"/>';
      }
      // treden tussen de rijen
      s += '<path d="M0 ' + (roof(0) + off + 5).toFixed(1);
      for (var tx = W / 24; tx <= W + .1; tx += W / 24) s += ' L' + tx.toFixed(1) + ' ' + (roof(tx) + off + 5).toFixed(1);
      s += '" fill="none" stroke="#000" stroke-opacity=".18" stroke-width="1"/>';
    }

    // twee lichtmasten
    [Math.min(70, W * .08), W - Math.min(70, W * .08)].forEach(function (mx) {
      s += '<ellipse cx="' + mx + '" cy="10" rx="46" ry="26" fill="url(#kfStandGlow)"/>'
        + '<rect x="' + (mx - 1.5) + '" y="12" width="3" height="' + (roof(mx) - 12).toFixed(1) + '" fill="#2a3a32"/>'
        + '<rect x="' + (mx - 17) + '" y="3" width="34" height="13" rx="2" fill="#1d2b24" stroke="#d6b25e" stroke-opacity=".5" stroke-width=".8"/>';
      for (var i = 0; i < 4; i++) for (var j = 0; j < 2; j++)
        s += '<rect x="' + (mx - 14 + i * 7.5) + '" y="' + (5.5 + j * 5) + '" width="5" height="3.2" rx=".8" fill="#fff4d6"/>';
    });

    s += '</svg>';
    wrap.innerHTML = s;
  }

  draw();
  var t = 0, lastW = wrap.clientWidth;
  addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { if (wrap.clientWidth !== lastW) { lastW = wrap.clientWidth; draw(); } }, 150);
  });
})();
